import { render, staticRenderFns } from "./SinglePieChart.vue?vue&type=template&id=69dec823&lang=pug&"
import script from "./SinglePieChart.vue?vue&type=script&lang=js&"
export * from "./SinglePieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports